import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../utils/config';

const initialContentState = {
    id: null,
    title: null,
    content: null,
    email_address: null,
    date_of_birth: null,
    place: null,
    phone_number: null,
    years_of_experience: null,
};

export const usePageContent = ( pageId ) => {
    const [isLoading, setIsLoading] = useState( true );
    const [content, setContent] = useState( initialContentState );
    const [error, setError] = useState( null );

    useEffect(() => {
        if ( !pageId ) return;

        const fetchContent = async() => {
            try {
                setIsLoading (true );
                const { data } = await axios.get( `${API_ENDPOINTS.PAGE_ENDPOINT}${pageId}`, {
                    headers:{ 'Content-type': 'application/json; charset=UTF-8' },
                });
                setContent( data );
            } catch ( error ) {
                console.error( 'Error fetching content:', error );
                setError( 'Failed to load page content.' );
            } finally {
                setIsLoading( false );
            }
        };
        
        fetchContent();
    },[pageId]);

    return { content, isLoading, error };
};